

angular.module('ngHtmlCompile', [])
    .directive('ngHtmlCompile', $compile => ({
        restrict: 'A',
        link(scope, element, attrs) {

            scope.$watch(attrs.ngHtmlCompile, (newValue) => {

                if (!newValue) {

                    return;

                }

                element.html(newValue);
                $compile(element.contents())(scope);

            });

        },
    }))
    .directive('directiveCompile', $compile => ({
        restrict: 'A',
        replace: true,
        link(scope, element, attrs) {

            element.html(`<div${attrs.directiveCompile}></div>`);
            $compile(element.contents())(scope);

        },
    }));



// WEBPACK FOOTER //
// ./scripts/common/directives/htmlCompile.js